import Checkbox from "components/common/Fields/Checkbox";
import ReactStrapTable from "components/reactStrapTable";
import SearchButtons from "components/SearchButtons";
import React, { useEffect, useRef, useState } from "react";
import columnSelectorIcon from "../../../../../assets/icon/column-selector.svg";
import editIocn from "../../../../../assets/inventory/edit-icon.svg";
import deleteIcon from "../../../../../assets/inventory/delete-icon.svg";
import CloseIcon from "../../../../../assets/icon/chatClose.svg";
import resetAllIcon from "../../../../../assets/icon/resetall.svg";
import applyIcon from "../../../../../assets/icon/apply.svg";

import {
  Button,
  ButtonGroup,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Offcanvas,
  OffcanvasBody,
} from "reactstrap";
import OrderEditDetails from "../OrderEditDetails";
import CreateManualOrder from "../CreateManualOrder";
import greenCheck from "assets/icon/340b-checkIcon.svg";

const rowData = [
  {
    id: 1167,
    account: "McKesson WAC",
    drugstatus: "Approval Required",
    drugname: "Lisinopril Tablet 10 MG",
    npcupc: "34981-3198-99",
    stockqty: "2,075",
    parlevel: "5,000",
    pending: "0",
    orderqty: "3",
    packages: "1000 EA (BTL)",
  },
  {
    id: 22,
    account: (
      <div className="d-flex " style={{ gap: "8px" }}>
        <div>McKesson</div>
        <div className="check-box-green">
          <img src={greenCheck} />
          340B
        </div>
      </div>
    ),
    drugstatus: "Approved Required",
    drugname: "Metformin Tablet 500 MG",
    npcupc: "00185-0450-01",
    stockqty: "758",
    parlevel: "6,000",
    pending: "2",
    orderqty: "3",
    packages: "1000 EA (BTL)",
  },
  {
    id: 33,
    account: "Anda Retail",
    drugstatus: "Manual Order",
    drugname: "Amoxicillin Capsule 250 MG",
    npcupc: "54868-3105-00",
    stockqty: "0",
    parlevel: "1,800",
    pending: "0",
    orderqty: "4",
    packages: "100 EA (BTL)",
  },
  {
    id: 44,
    account: "McKesson WAC",
    drugstatus: "Manual Order",
    drugname: "Alprazolam Tablet 1 MG",
    npcupc: "00093-7138-01",
    stockqty: "97",
    parlevel: "500",
    pending: "0",
    orderqty: "4",
    packages: "100 EA (BTL)",
  },
  {
    id: 55,
    all: <Checkbox />,
    account: "McKesson WAC",
    drugstatus: "Backordered",
    drugname: "Atorvastatin Tablet 20 MG",
    npcupc: "43598-0600-90",
    stockqty: "0",
    parlevel: "280",
    pending: "0",
    orderqty: "3",
    packages: "90 EA (BTL)",
  },
  {
    id: 221,
    account: "McKesson WAC",
    drugstatus: "Ready (Approved)",
    drugname: "Hydrochlorothiazide Tablet 25 MG",
    npcupc: "53746-0171-01",
    stockqty: "62",
    parlevel: "500",
    pending: "0",
    orderqty: "4",
    packages: "100 EA (BTL)",
  },
  {
    id: 662,
    account: "BluPax",
    drugstatus: "Ready",
    drugname: "Losartan Tablet 50 MG",
    npcupc: "69367-0145-01",
    stockqty: "207",
    parlevel: "600",
    pending: "0",
    orderqty: "4",
    packages: "100 EA (BTL)",
  },
  {
    id: 664,
    account: (
      <div className="d-flex " style={{ gap: "8px" }}>
        <div>McKesson</div>
        <div className="check-box-green">
          <img src={greenCheck} />
          340B
        </div>
      </div>
    ),
    drugstatus: "Ready (Approved)",
    drugname: "Simvastatin Tablet 40 MG",
    npcupc: "00093-7424-01",
    stockqty: "90",
    parlevel: "700",
    pending: "2",
    orderqty: "4",
    packages: "100 EA (BTL)",
  },
  {
    id: 225,
    account: "Anda Retail",
    drugstatus: "Ready",
    drugname: "Levothyroxine Tablet 50 MG",
    npcupc: "54868-5582-00",
    stockqty: "233",
    parlevel: "600",
    pending: "0",
    orderqty: "4",
    packages: "100 EA (BTL)",
  },
  {
    id: 226,
    account: "Baxter",
    drugstatus: "Ready",
    drugname: "Sodium Chloride IV Bag 0.9%",
    npcupc: "0338-0049-03	",
    stockqty: "5,000",
    parlevel: "30,000",
    pending: "0",
    orderqty: "1",
    packages: "24x1000 ML/CASE",
  },
  {
    id: 227,
    account: "McKesson WAC",
    drugstatus: "Ready",
    drugname: "Omeprazole Capsule 20 MG",
    npcupc: "59762-0230-01",
    stockqty: "416",
    parlevel: "500",
    pending: "0",
    orderqty: "1",
    packages: "100 EA (BTL)",
  },
  {
    id: 229,
    account: "BluPax",
    drugstatus: "Ready",
    drugname: "Gabapentin Capsule 300 MG",
    npcupc: "00591-0460-01",
    stockqty: "203",
    parlevel: "650",
    pending: "0",
    orderqty: "4",
    packages: "100 EA (BTL)",
  },
  {
    id: 220,
    account: (
      <div className="d-flex " style={{ gap: "8px" }}>
        <div>McKesson</div>
        <div className="check-box-green">
          <img src={greenCheck} />
          340B
        </div>
      </div>
    ),
    drugstatus: "Ready",
    drugname: "Amlodipine Tablet 10 MG",
    npcupc: "68180-0987-09",
    stockqty: "210",
    parlevel: "430",
    pending: "1",
    orderqty: "2",
    packages: "90 EA (BTL)",
  },
  {
    id: 2233,
    account: "Anda Retail",
    drugstatus: "Ready",
    drugname: "Sertraline Tablet 100 MG",
    npcupc: "00591-0467-01",
    stockqty: "82",
    parlevel: "500",
    pending: "0",
    orderqty: "4",
    packages: "100 EA (BTL)",
  },
  {
    id: 22222,
    account: "BluPax",
    drugstatus: "Ready",
    drugname: "Clonazepam Tablet 0.5 MG",
    npcupc: "00093-0052-01",
    stockqty: "0",
    parlevel: "300",
    pending: "0",
    orderqty: "3",
    packages: "100 EA (BTL)",
  },
  {
    id: 22123,
    account: (
      <div className="d-flex " style={{ gap: "8px" }}>
        <div>McKesson</div>
        <div className="check-box-green">
          <img src={greenCheck} />
          340B
        </div>
      </div>
    ),
    drugstatus: "Ready",
    drugname: "Prednisone Tablet 20 MG",
    npcupc: "54868-2341-01",
    stockqty: "183",
    parlevel: "600",
    pending: "1",
    orderqty: "3",
    packages: "100 EA (BTL)",
  },
  {
    id: 212,
    account: "McKesson WAC",
    drugstatus: "Ready",
    drugname: "Warfarin Tablet 5 MG",
    npcupc: "00093-5052-05",
    stockqty: "320",
    parlevel: "700",
    pending: "0",
    orderqty: "4",
    packages: "100 EA (BTL)",
  },
  {
    id: 422,
    account: "Anda Retail",
    drugstatus: "Ready",
    drugname: "Diazepam Tablet 5 MG",
    npcupc: "0093-2927-01",
    stockqty: "115",
    parlevel: "600",
    pending: "0",
    orderqty: "5",
    packages: "100 EA (BTL)",
  },
  {
    id: 922,
    account: "BluPax",
    drugstatus: "Ready",
    drugname: "Ranitidine Tablet 150 MG",
    npcupc: "00591-0462-01",
    stockqty: "0",
    parlevel: "300",
    pending: "0",
    orderqty: "3",
    packages: "100 EA (BTL)",
  },
  {
    id: 262,
    account: (
      <div className="d-flex " style={{ gap: "8px" }}>
        <div>McKesson</div>
        <div className="check-box-green">
          <img src={greenCheck} />
          340B
        </div>
      </div>
    ),
    drugstatus: "Ready",
    drugname: "Furosemide Tablet 40 MG",
    npcupc: "00781-1341-01",
    stockqty: "0",
    parlevel: "300",
    pending: "1",
    orderqty: "2",
    packages: "100 EA (BTL)",
  },
];

const checkBoxRenderer = () => {
  return (
    <div>
      <Checkbox />
    </div>
  );
};

const IconsRenderer = () => {
  return (
    <div>
      <img src={editIocn} className="cursor-pointer" /> <img src={deleteIcon} />
    </div>
  );
};

const renderSwitch = () => {
  return (
    <div>
      <FormGroup style={{ fontSize: "large", marginLeft: "20px" }} switch>
        <Input type="switch" />
      </FormGroup>
    </div>
  );
};

const columnData = [
  {
    id: "1",
    dataField: "all",
    text: (
      <div className="d-flex justify-content-start align-items-center gap-2">
        <Checkbox /> All
      </div>
    ),
    show: true,
    cellRenderer: () => checkBoxRenderer(),
    // width -- do not use width here. we are directly giving in css file for fixed columns because of iocns
  },
  {
    id: "2",
    dataField: "option",
    text: "Options",
    show: true,
    cellRenderer: () => IconsRenderer(),

    // width -- do not use width here. we are directly giving in css file for fixed columns because of iocns
  },
  {
    id: "3",
    dataField: "donosub",
    text: "Do Not Sub",
    show: true,
    cellRenderer: () => renderSwitch(),

    // width -- do not use width here. we are directly giving in css file for fixed columns because of iocns
  },
  {
    id: "4",
    dataField: "account",
    text: "Account",
    show: true,
    width: 50,
    sort: true,
  },
  {
    id: "5",
    dataField: "drugstatus",
    text: "Drug Status",
    show: true,
    width: 180,
    sort: true,
  },
  {
    id: "6",
    dataField: "drugname",
    text: "Drug Name",
    show: true,
    width: 250,
    sort: true,
  },
  {
    id: "12",
    dataField: "packages",
    text: "Packages",
    show: true,
    width: 150,
    sort: true,
  },
  {
    id: "7",
    dataField: "npcupc",
    text: "NDC/UPC",
    show: true,
    width: 150,
    sort: true,
  },
  {
    id: "8",
    dataField: "stockqty",
    text: "Stock Qty",
    show: true,
    width: 120,
    sort: true,
  },
  {
    id: "9",
    dataField: "parlevel",
    text: "Par Level",
    show: true,
    width: 110,
    sort: true,
  },
  {
    id: "10",
    dataField: "pending",
    text: "Pending 340B",
    show: true,
    width: 140,
    sort: true,
  },
  {
    id: "11",
    dataField: "orderqty",
    text: "Order QTY",
    show: true,
    width: 110,
    sort: true,
  },
];

const ToBeOrders = () => {
  const dropdownRef = useRef(null);
  const [editDetails, setEditDetails] = useState(false);
  const [manualOrder, setManualOrder] = useState(false);
  const [rowDetails, setRowDetails] = useState(false);
  const [tableData, setTableData] = useState(rowData);
  const [data, setData] = useState([]);
  const [updateData, setUpdateData] = useState(() => columnData.slice(0, 8));
  const [rSelected, setRSelected] = useState("off");
  const [columnOpen, setColumnOpen] = useState(false);

  const [check, setCheck] = useState({
    selectall: "",
    account: true,
    drugstatus: true,
    drugname: true,
    ndcupc: true,
    stockqty: "",
    parlevel: "",
    packages: true,
    pending: "",
    orderqty: "",
  });

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    if (name === "selectall") {
      setCheck({
        selectall: checked,
        account: checked,
        drugstatus: checked,
        drugname: checked,
        ndcupc: checked,
        stockqty: checked,
        parlevel: checked,
        packages: checked,
        pending: checked,
        orderqty: checked,
      });
    } else {
      setCheck((prevCheck) => {
        const updatedCheck = { ...prevCheck, [name]: checked };
        const allSelected = Object.values(updatedCheck).every(
          (val) => val === true
        );
        updatedCheck.selectall = allSelected;
        return updatedCheck;
      });
    }
  };

  const totalCount = [
    check.account,
    check.drugname,
    check.drugstatus,
    check.ndcupc,
    check.stockqty,
    check.orderqty,
    check.parlevel,
    check.packages,
    check.pending,
  ].filter(Boolean).length;

  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };

  const tableFilterData = tableData.length
    ? tableData.map((patient) => {
        return {
          id: patient.id,
          all: patient.all,
          donosub: patient.donosub,
          option: patient.option,
          drugstatus: patient.drugstatus,
          packages: patient.packages,
          account: patient.account,
          drugname: patient.drugname,
          npcupc: patient.npcupc,
          orderqty: patient.orderqty,
          stockqty: patient.stockqty,
          parlevel: patient.parlevel,
          packages: patient.packages,
          pending: patient.parlevel,
        };
      })
    : [
        {
          id: "",
          all: "",
          donosub: "",
          drugstatus: "",
          option: "",
          account: "",
          drugname: "",
          packages: "",
          npcupc: "",
          orderqty: "",
          stockqty: "",
          parlevel: "",
          pending: "",
          packages: "",
        },
      ];

  const filterColumns = () => {
    const mandatoryIndexes = [0, 1, 2, 4, 7];

    const selectedIndexes = Object.entries(check)
      .filter(([key, value]) => value === true)
      .map(([key]) => {
        if (key === "account") return 3;
        if (key === "drugstatus") return 4;
        if (key === "drugname") return 5;
        if (key === "packages") return 6;
        if (key === "ndcupc") return 7;
        if (key === "stockqty") return 8;
        if (key === "parlevel") return 9;
        if (key === "pending") return 10;
        if (key === "orderqty") return 11;
        return -1;
      })
      .filter((index) => index !== -2);

    const uniqueIndexes = Array.from(
      new Set([...mandatoryIndexes, ...selectedIndexes])
    );

    return columnData.filter((_, index) => uniqueIndexes.includes(index));
  };

  const filteredColData = filterColumns();

  const handleSubmit = () => {
    setUpdateData(filteredColData.length > 0 ? filteredColData : columnData);
    setColumnOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setColumnOpen(false);
      }
    };

    if (columnOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [columnOpen]);

  return (
    <div className="table-card scroll-table position-relative border-0 pt-1 pb-1 rounded bg-white">
      <div className="d-flex justify-content-between">
        <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <div>
            <SearchButtons
              InSize={200}
              placeHolder={"Search by Drug Name"}
              data={data}
              setFilterData={setTableData}
            />
          </div>
          <div ref={dropdownRef}>
            <Dropdown isOpen={columnOpen} toggle={() => {}}>
              <DropdownToggle onClick={() => setColumnOpen((prev) => !prev)}>
                <img src={columnSelectorIcon} alt="not available" />
                <span>
                  Columns{" "}
                  {totalCount > 0 && (
                    <div className="totalcount">{totalCount}</div>
                  )}
                </span>
              </DropdownToggle>
              <DropdownMenu className="drop-down-clm">
                <DropdownItem className="dropdownitem-border mb-0 drp-down-clm-item">
                  <Input
                    type="checkbox"
                    name="selectall"
                    checked={check.selectall}
                    value={check.selectall}
                    onChange={handleCheck}
                  />
                  <span className="m-2">Select All</span>
                </DropdownItem>
                <DropdownItem className="dropdownitem-border mb-0 drp-down-clm-item">
                  <Input
                    type="checkbox"
                    name="drugstatus"
                    checked={check.drugstatus}
                    value={check.drugstatus}
                    onChange={handleCheck}
                    disabled
                  />
                  <span className="m-2">Drug Status</span>
                </DropdownItem>
                <DropdownItem className="dropdownitem-border mb-0 drp-down-clm-item">
                  <Input
                    type="checkbox"
                    name="ndcupc"
                    checked={check.ndcupc}
                    value={check.ndcupc}
                    onChange={handleCheck}
                    disabled
                  />
                  <span className="m-2">NDC/UPC</span>
                </DropdownItem>
                <DropdownItem className="dropdownitem-border mb-0 drp-down-clm-item">
                  <Input
                    type="checkbox"
                    name="account"
                    checked={check.account}
                    value={check.account}
                    onChange={handleCheck}
                  />
                  <span className="m-2">Account</span>
                </DropdownItem>
                <DropdownItem className="dropdownitem-border mb-0 drp-down-clm-item">
                  <Input
                    type="checkbox"
                    name="drugname"
                    checked={check.drugname}
                    value={check.drugname}
                    onChange={handleCheck}
                  />
                  <span className="m-2">Drug Name</span>
                </DropdownItem>
                <DropdownItem className="dropdownitem-border mb-0 drp-down-clm-item">
                  <Input
                    type="checkbox"
                    name="packages"
                    checked={check.packages}
                    value={check.packages}
                    onChange={handleCheck}
                  />
                  <span className="m-2">Packages</span>
                </DropdownItem>
                <DropdownItem className="dropdownitem-border mb-0 drp-down-clm-item">
                  <Input
                    type="checkbox"
                    name="stockqty"
                    checked={check.stockqty}
                    value={check.stockqty}
                    onChange={handleCheck}
                  />
                  <span className="m-2">Stock Qty</span>
                </DropdownItem>
                <DropdownItem className="dropdownitem-border mb-0 drp-down-clm-item">
                  <Input
                    type="checkbox"
                    name="parlevel"
                    checked={check.parlevel}
                    value={check.parlevel}
                    onChange={handleCheck}
                  />
                  <span className="m-2">Par Level</span>
                </DropdownItem>
                <DropdownItem className="dropdownitem-border mb-0 drp-down-clm-item">
                  <Input
                    type="checkbox"
                    name="pending"
                    checked={check.pending}
                    value={check.pending}
                    onChange={handleCheck}
                  />
                  <span className="m-2">Pending 340 B</span>
                </DropdownItem>
                <DropdownItem className="dropdownitem-border mb-0 drp-down-clm-item">
                  <Input
                    type="checkbox"
                    name="orderqty"
                    checked={check.orderqty}
                    value={check.orderqty}
                    onChange={handleCheck}
                  />
                  <span className="m-2">Order Qty</span>
                </DropdownItem>
                <div className="d-flex justify-content-center align-items-center p-2">
                  <Button
                    onClick={() =>
                      setCheck({
                        selectall: false,
                        account: false,
                        drugname: false,
                        // ndcupc: false,
                        stockqty: false,
                        // drugstatus: false,
                        parlevel: false,
                        pending: false,
                        orderqty: false,
                        packages: false,
                      })
                    }
                  >
                    {" "}
                    <img src={resetAllIcon} alt="" />
                    Reset All
                  </Button>
                  <Button
                    color="primary"
                    onChange={handleCheck}
                    onClick={handleSubmit}
                  >
                    {" "}
                    <img src={applyIcon} alt="" /> Apply
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </div>
          <div className="d-flex justify-content-end align-items-center gap-2">
            <span className="f-16 font-weight-600">Filter</span>
            <ButtonGroup className="filter-btn-group">
              <Button
                color="info"
                outline
                onClick={toggleFilter}
                active={rSelected === "off"}
              >
                OFF
              </Button>
              <Button
                color="info"
                outline
                active={rSelected === "on"}
                onClick={toggleFilter}
              >
                ON
              </Button>
            </ButtonGroup>
          </div>
        </div>
        <div className="d-flex">
          <Button className="back-button">Submit</Button>
          <Button color="primary" onClick={() => setManualOrder(!manualOrder)}>
            Create Manual Order
          </Button>
        </div>
      </div>
      <div fixed-height={rowData.length > 0 ? "fixed-height" : "default"}>
        <ReactStrapTable
          fixedColumn={[1, 2, 3]}
          id="purchase-tobe-orders"
          columns={updateData.length > 0 ? updateData : columnData}
          data={tableFilterData}
          row={rowData}
          redRow={[2]}
          enablerowRouting={true}
          handleRowClick={() => setRowDetails(!rowDetails)}
        />
      </div>
      <div>
        <Offcanvas
          direction="end"
          isOpen={rowDetails}
          toggle={() => setRowDetails(!rowDetails)}
        >
          <div className="casvas-header p-3">
            <div>View Details</div>
            <div
              className="cursor-pointer"
              onClick={() => setRowDetails(!rowDetails)}
            >
              <img src={CloseIcon} />
            </div>
          </div>
          <div className="section-devider-border-popup"></div>
          <OffcanvasBody className="p-4 pt-1">
            <OrderEditDetails />
          </OffcanvasBody>
        </Offcanvas>
      </div>
      <div>
        <Offcanvas
          direction="end"
          isOpen={editDetails}
          toggle={() => setEditDetails(!editDetails)}
        >
          <div className="casvas-header p-3">
            <div>Edit Details</div>
            <div
              className="cursor-pointer"
              onClick={() => setEditDetails(!editDetails)}
            >
              <img src={CloseIcon} />
            </div>
          </div>
          <div className="section-devider-border-popup"></div>
          <OffcanvasBody className="p-4 pt-1">
            <OrderEditDetails />
          </OffcanvasBody>
          <div className="footer-btns">
            <div>
              <Button color="primary" className="reset">
                Reset
              </Button>
            </div>
            <div className="d-flex">
              <Button color="primary" className="reset">
                Save
              </Button>
              <Button color="primary">Submit</Button>
            </div>
          </div>
        </Offcanvas>
      </div>
      <div>
        <Offcanvas
          isOpen={manualOrder}
          toggle={() => setManualOrder(!manualOrder)}
          direction="end"
        >
          <div className="casvas-header p-3 pb-1">
            <div>Create Manual Order</div>
            <div
              className="cursor-pointer"
              onClick={() => setManualOrder(!manualOrder)}
            >
              <img src={CloseIcon} />
            </div>
          </div>
          <div className="section-devider-border-popup"></div>
          <OffcanvasBody>
            <CreateManualOrder />
          </OffcanvasBody>
        </Offcanvas>
      </div>
    </div>
  );
};

export default ToBeOrders;
